export default __webpack_public_path__ + "static/fordelar-med-casino-med-swish-bc8fb9c0d148d4828451def1a2d95889.jpg";